export const INTERIM_CHAMPION_STATUS = 'interim'

const isPlainObject = value =>
  Boolean(value) && typeof value === 'object' && !Array.isArray(value)

export const normalizeChampionStatusByTitle = (
  statusByTitle = {},
  championTypes = []
) => {
  const allowedTitles = new Set(
    Array.isArray(championTypes) ? championTypes.filter(Boolean) : []
  )

  if (!isPlainObject(statusByTitle) || allowedTitles.size === 0) {
    return {}
  }

  return Object.entries(statusByTitle).reduce((acc, [titleValue, status]) => {
    if (
      allowedTitles.has(titleValue) &&
      status === INTERIM_CHAMPION_STATUS
    ) {
      acc[titleValue] = INTERIM_CHAMPION_STATUS
    }

    return acc
  }, {})
}

export const getChampionStatusForTitle = (wrestler = {}, titleValue = '') => {
  if (!titleValue) return ''

  const normalizedStatuses = normalizeChampionStatusByTitle(
    wrestler?.championStatusByTitle,
    wrestler?.championTypes
  )

  return normalizedStatuses[titleValue] || ''
}

export const isInterimChampionForTitle = (wrestler = {}, titleValue = '') =>
  getChampionStatusForTitle(wrestler, titleValue) ===
  INTERIM_CHAMPION_STATUS
